/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: utQE8oqBBjiK
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicButtonDock.module.css"; // plasmic-import: utQE8oqBBjiK/css
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: sRgpLHilAR4G/icon

createPlasmicElementProxy;

export const PlasmicButtonDock__VariantProps = new Array("status", "color");

export const PlasmicButtonDock__ArgProps = new Array("iconTab", "onClick");

const $$ = {};

function PlasmicButtonDock__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"dockButtonWrapper"}
      data-plasmic-override={overrides.dockButtonWrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.dockButtonWrapper,
        {
          [sty.dockButtonWrappercolor_light]: hasVariant(
            $state,
            "color",
            "light"
          ),
          [sty.dockButtonWrapperstatus__default]: hasVariant(
            $state,
            "status",
            "_default"
          ),
          [sty.dockButtonWrapperstatus_selected]: hasVariant(
            $state,
            "status",
            "selected"
          )
        }
      )}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      <div
        data-plasmic-name={"dockButton"}
        data-plasmic-override={overrides.dockButton}
        className={classNames(projectcss.all, sty.dockButton, {
          [sty.dockButtoncolor_light]: hasVariant($state, "color", "light"),
          [sty.dockButtonstatus__default]: hasVariant(
            $state,
            "status",
            "_default"
          ),
          [sty.dockButtonstatus_selected]: hasVariant(
            $state,
            "status",
            "selected"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <div
              className={classNames(projectcss.all, sty.freeBox__cfm4, {
                [sty.freeBoxstatus_selected__cfm4I36Nh]: hasVariant(
                  $state,
                  "status",
                  "selected"
                )
              })}
            >
              <Icon2Icon
                className={classNames(projectcss.all, sty.svg___0RHL)}
                role={"img"}
              />
            </div>
          ),

          value: args.iconTab
        })}
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxstatus__default]: hasVariant(
            $state,
            "status",
            "_default"
          ),
          [sty.freeBoxstatus_selected]: hasVariant($state, "status", "selected")
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  dockButtonWrapper: ["dockButtonWrapper", "dockButton", "freeBox"],
  dockButton: ["dockButton"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonDock__ArgProps,
          internalVariantPropNames: PlasmicButtonDock__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonDock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dockButtonWrapper") {
    func.displayName = "PlasmicButtonDock";
  } else {
    func.displayName = `PlasmicButtonDock.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonDock = Object.assign(
  // Top-level PlasmicButtonDock renders the root element
  makeNodeComponent("dockButtonWrapper"),
  {
    // Helper components rendering sub-elements
    dockButton: makeNodeComponent("dockButton"),
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicButtonDock
    internalVariantProps: PlasmicButtonDock__VariantProps,
    internalArgProps: PlasmicButtonDock__ArgProps
  }
);

export default PlasmicButtonDock;
/* prettier-ignore-end */
